import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UiFormModule } from "../../../shared/ui/ui-form.module";
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { RouterModule } from "@angular/router";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { SharedModule } from "../../shared/shared.module";
import { FinancingDetailModule } from "../financing-detail/financing-detail.module";


import { MatAutocompleteModule } from "@angular/material/autocomplete";

import { OwnFinancingListComponent } from "../own-financing/components/own-financing-list/own-financing-list.components";
import {OwnFinancingReducer} from './store/reducers/own-financing.reducer'
import {OwnFinancingService} from './services/own-financing.service'
import {OwnFinancingEffects} from './store/effects/own-financing.effects'




@NgModule({
  declarations:[
    OwnFinancingListComponent
  ],
  exports:[
    OwnFinancingListComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    UiFormModule,
    RouterModule,
    FormsModule,
    SharedModule,
    FinancingDetailModule,

    // Angular Material
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatCardModule,
    MatDividerModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatSnackBarModule,

    // NgRx
    StoreModule.forFeature('ownFinancing', OwnFinancingReducer),
    EffectsModule.forFeature([OwnFinancingEffects])
  ],
  providers: [
    OwnFinancingService
  ]
})

export class OwnFinancingModule { }
